export const loginEventsConfig = {
    parentSelector: '.customer.login', // Scope events to the login/recover form sections
    events: {
        // Login | focus in text field (CSV Line 193)
        loginFocus: {
            selector: '#CustomerEmail, #CustomerPassword, #RecoverEmail', // Target both login and recover email/password fields
            event: {
                event: 'login', // Event name from CSV
                component: 'login', // Component name from CSV
                element: 'text_field',
                action: 'focus',
                trigger: 'focus',
                getDynamicData: (element) => {
                    // Find the associated label for the field name
                    const label = document.querySelector(`label[for="${element.id}"]`);
                    // Standardize field name extraction
                    const fieldName = label ? label.textContent.trim() : (element.id === 'CustomerEmail' || element.id === 'RecoverEmail' ? 'E-MAIL' : 'WACHTWOORD'); 
                    return {
                        field_name: fieldName
                    };
                }
            }
        },

        // Login | input in text_field (CSV Line 194)
        loginInput: {
             selector: '#CustomerEmail, #CustomerPassword, #RecoverEmail', // Target both login and recover email/password fields
            event: {
                event: 'login',
                component: 'login',
                element: 'text_field',
                action: 'input',
                trigger: 'input', // Debounced by datalayer.js
                getDynamicData: (element) => {
                    const label = document.querySelector(`label[for="${element.id}"]`);
                     const fieldName = label ? label.textContent.trim() : (element.id === 'CustomerEmail' || element.id === 'RecoverEmail' ? 'E-MAIL' : 'WACHTWOORD');
                    // Don't capture password value for security
                    return {
                        field_name: fieldName,
                        // Only include input_value for non-password fields if needed
                        input_value: element.type !== 'password' ? element.value : undefined 
                    };
                }
            }
        },

        // Login | click on cta-button (CSV Line 196) - Includes Login and Recover Submit
        loginSubmitClick: {
            selector: '#customer_login button, form[action="/account/recover"] button', // Target login submit and recover submit
            event: {
                event: 'login',
                component: 'login',
                element: 'cta_button',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => {
                    // Get button text from its span or directly
                    const buttonText = element.querySelector('span')?.textContent.trim() || element.textContent.trim();
                    return {
                        click_text: buttonText 
                    };
                }
            }
        },

        // Login | click on text link (wachtwoord vergeten / account aanmaken) (CSV Line 198)
        // Also includes "Annuleren" link from recover form
        loginLinkClick: {
            selector: '#customer_login a, form[action="/account/recover"] a', // Target links within both forms
            event: {
                event: 'login',
                component: 'login',
                element: 'link',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => { // element is the <a> tag
                    return {
                        link_text: element.textContent.trim(),
                        link_url: element.getAttribute('href') // Get href attribute value
                    };
                }
            }
        },
        
        // NOTE: login valid (CSV Line 197) and text field error (CSV Line 195) 
        // are harder to track reliably client-side without observing form submission 
        // responses or specific error message elements appearing. These are omitted for now.

    }
}; 